import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-chess-competition',
  templateUrl: './chess-competition.component.html',
  styleUrls: ['./chess-competition.component.scss']
})
export class ChessCompetitionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
